import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import inventoryServices from '../inventoryServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import moment from 'moment';


function InventoryForm({callBack }) {

    const {AppAlert} = useAlert();
    const {vendorDD, productDD,projectLocationDD,companyDD} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {        
        companyId:"",
        vendorId:"",
        locationId:"",
        productId:"",
        qty:"",
        cost:"",
        refId:"",
        receiveDate:moment().format(moment.HTML5_FMT.DATE),
        receivedBy:"",
    }

    const validationRule = Yup.object({
        companyId:Yup.string().required("Required"),
        vendorId:Yup.string().required("Required"),
        productId:Yup.string().required("Required"),
        locationId:Yup.string().required("Required"),
        qty:Yup.string().required("Required"),
        cost:Yup.string().required("Required"),
        //refId:Yup.string().required("Required"),
        receiveDate:Yup.string().required("Required"),
        receivedBy:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        inventoryServices.add(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            
            <Tooltip title="Add New">
                <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Inventory</button>
            </Tooltip>
            
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Inventory Form"}</DialogTitle>
                                    <DialogContent>

                                            
                                            <div className="row p-3">

                                                <div className="col-md-4 my-2" >
                                                    <h4>Select Company</h4>
                                                    {companyDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Select Company / Firm " name="companyId"  
                                                            options={companyDD} multiple={false} 
                                                        />
                                                    }
                                                </div>


                                                <div className='col-md-4 my-2'>
                                                    <h4>Select Vendor</h4>
                                                    {vendorDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Select Vendor" name="vendorId"  
                                                            options={vendorDD} multiple={false} 
                                                        />
                                                    }
                                                </div>


                                                <div className='col-md-4 my-2'>
                                                    <h4>Inventory Location</h4>
                                                    {projectLocationDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Receiving / Warehouse Location " name="locationId"  
                                                            options={projectLocationDD} multiple={false} 
                                                        />
                                                    }
                                                </div>
                                                
                                                <hr/>

                                                <div className='col-md-4 my-2'>
                                                    {productDD &&
                                                        <FormikControl control="autoselect" formik={formik} 
                                                            label="Product" name="productId"  
                                                            options={productDD} multiple={false} 
                                                        />
                                                    }
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Qty #" name="qty" 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Receiveing Date" name="receiveDate" 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number" 
                                                        label="Cost" name="cost" 
                                                    />
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Reference Id" name="refId" 
                                                    />
                                                </div>
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Received By" name="receivedBy" 
                                                    />
                                                </div>

                                                

                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik) */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default InventoryForm